export const CELL = 10
export const PITCH = 14
export const CYCLE = 2400

export function cellsIn(width: number): number {
  return Math.max(1, Math.floor((width + PITCH - CELL) / PITCH))
}

export function span(cells: number): number {
  return cells * PITCH - (PITCH - CELL)
}

export function cycleStart(time: number): number {
  return Math.floor(time / CYCLE) * CYCLE
}

export function heightDelay(lineTop: number, regionTop: number): number {
  return Math.min(900, Math.max(0, 0.9 * (lineTop - regionTop)))
}

/**
 * One loop of the page clock. The ink layer is a whole number of pitches long
 * and slides in whole-pitch steps under an overflow clip, so each step shows
 * one more cell exactly where a clip would. A transform runs on the
 * compositor; a clip-path loop repaints every line on every step.
 */
export function clockKeyframes(
  cells: number,
  delay: number,
  hidden: string,
  cleared = hidden,
  millisecondsPerCell = 45,
): Keyframe[] {
  const count = Math.max(1, Math.floor(cells))
  const start = Math.min(900, Math.max(0, delay))
  const duration = Math.min(count * millisecondsPerCell, 600)
  const steps = `steps(${count}, jump-start)`
  return [
    { transform: hidden, offset: 0 },
    { transform: hidden, offset: start / CYCLE, easing: steps },
    { transform: 'none', offset: (start + duration) / CYCLE },
    { transform: 'none', offset: (CYCLE - 320) / CYCLE, easing: steps },
    { transform: cleared, offset: (CYCLE - 80) / CYCLE },
    { transform: cleared, offset: 1 },
  ]
}

export function lineKeyframes(cells: number, delay: number, rtl: boolean): Keyframe[] {
  const length = Math.max(1, Math.floor(cells)) * PITCH
  return clockKeyframes(cells, delay, `translateX(${rtl ? '' : '-'}${length}px)`)
}
